// extracted by mini-css-extract-plugin
module.exports = {"container":"promoItem__container___v1lH0","is-live":"promoItem__is-live___2FH-n","is-match":"promoItem__is-match___2kJf_","is-combo":"promoItem__is-combo___3tQca"};